import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Loading from 'components/layout/loading';
import { useCustomerStatusOnEnter } from 'hooks/useCustomerStatus';

import RefuelContainer from './RefuelContainer';

import { RefuelProvider } from './hooks/useNewRefuel';

const NewRefuel: React.FC = () => {
  const history = useHistory();
  const { destination, isLoading } = useCustomerStatusOnEnter();

  useEffect(() => {
    if (isLoading) return;
    if (destination === 'pendencias') history.replace('/pendencias');
  }, [destination, isLoading, history]);

  if (isLoading || destination === 'pendencias') {
    return <Loading />;
  }

  return (
    <RefuelProvider>
      <RefuelContainer />
    </RefuelProvider>
  );
};

export default NewRefuel;
